<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>

         <v-card class="cpd-list-card">
            <v-toolbar flat color="white">
               <v-toolbar-title>CPD Categories</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark class="mr-2" href="/admin/cpd">Member CPD</v-btn>
               <v-btn color="primary" dark @click="loadItems" :loading="loading">Refresh</v-btn>
            </v-toolbar>

            <v-data-table
               :headers="headers"
               :items="items"
               :loading="loading"
               class="border cpd-table"
               no-data-text="No data available"
            ></v-data-table>
         </v-card>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOACpdEventProgCat',
   components: { DashboardLayout, BaseBreadcrumb },
   data() {
      return {
         page: { title: 'CPD Management' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'CPD Management', disabled: false, to: '/admin/cpd' },
            { text: 'CPD Categories', disabled: true },
         ],
         loading: false,
         items: [],
         headers: [
            { text: 'Category', value: 'category' },
            { text: 'Points', value: 'catpoints' },
         ],
      }
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      loadItems() {
         this.loading = true
         axios.get('/admin/cpd-evtprg-cat/list')
            .then((resp) => {
               this.items = resp.data && resp.data.status === 'OK' ? (resp.data.data || []) : []
            })
            .finally(() => {
               this.loading = false
            })
      },
   },
}
</script>

<style scoped>
.cpd-list-card ::v-deep .v-toolbar__title {
   font-size: 18px;
   font-weight: 500;
}

.cpd-table ::v-deep .v-data-table-header th {
   font-size: 12px;
   font-weight: 600;
}

.cpd-table ::v-deep tbody td {
   font-size: 12px;
}
</style>
